import {
  ElementNode,
  type EditorConfig,
  type LexicalNode,
  type SerializedElementNode,
  type DOMConversionMap,
  type DOMConversionOutput,
  type DOMExportOutput,
  type LexicalEditor,
  type Spread,
} from 'lexical';

export type SerializedSpoilerNode = Spread<
  { type: 'spoiler'; version: 1 },
  SerializedElementNode
>;

export class SpoilerNode extends ElementNode {
  static getType(): string {
    return 'spoiler';
  }

  static clone(node: SpoilerNode): SpoilerNode {
    return new SpoilerNode(node.__key);
  }

  createDOM(config: EditorConfig): HTMLElement {
    const span = document.createElement('span');
    span.className = (config.theme.spoiler as string | undefined) ?? 'tg-spoiler';
    return span;
  }

  updateDOM(_prevNode: SpoilerNode, _dom: HTMLElement): boolean {
    return false;
  }

  exportJSON(): SerializedSpoilerNode {
    return {
      ...super.exportJSON(),
      type: 'spoiler',
      version: 1,
    };
  }

  static importJSON(_serializedNode: SerializedSpoilerNode): SpoilerNode {
    return $createSpoilerNode();
  }

  exportDOM(_editor: LexicalEditor): DOMExportOutput {
    const element = document.createElement('tg-spoiler');
    return { element };
  }

  static importDOM(): DOMConversionMap | null {
    return {
      'tg-spoiler': () => ({
        conversion: convertSpoilerElement,
        priority: 1,
      }),
      span: (domNode: HTMLElement) => {
        if (
          domNode.classList.contains('tg-spoiler') ||
          domNode.classList.contains('spoiler')
        ) {
          return {
            conversion: convertSpoilerElement,
            priority: 1,
          };
        }
        return null;
      },
    };
  }

  isInline(): boolean {
    return true;
  }

  canInsertTextBefore(): boolean {
    return true;
  }

  canInsertTextAfter(): boolean {
    return true;
  }

  canBeEmpty(): boolean {
    return true;
  }
}

function convertSpoilerElement(): DOMConversionOutput {
  return { node: $createSpoilerNode() };
}

export function $createSpoilerNode(): SpoilerNode {
  return new SpoilerNode();
}

export function $isSpoilerNode(
  node: LexicalNode | null | undefined
): node is SpoilerNode {
  return node instanceof SpoilerNode;
}
